export const ACTIONBUTTON_LOCALSTORAGE_KEY = 'actionButtonDisplayRules';

export const ACTIONBUTTON_EXPRESSIONS_GENERATED = 'ACTION_BUTTON_DISPLAYS_GENERATED';
